module.exports = __webpack_public_path__ + "img/lock.7dcdea2c.svg";